export const insuranceTypes = {
  applicant: 0,
  guarantor: 1,
  pcr: 2,
};

export const confidenceScoreThresholdEligibility = 0.44;
